import React from 'react';
import { ContentDivider, Popover } from '@milanote/roma';
import BoardLinkSearchBar from './BoardLinkSearchBar';
import { useBoardLinkContent } from './useBoardLinkContent';
import BoardLinkList from './BoardLinkList';

const BoardLinkPopupContent: React.FC = () => {
    const { searchQuery, setSearchQuery, gridSize, filteredBoards, handleBoardSelect } = useBoardLinkContent();

    return (
        <div className="BoardLinkPopupContent flex min-h-0 flex-col">
            <BoardLinkSearchBar
                className="mb-2"
                query={searchQuery}
                onQueryChange={setSearchQuery}
                autoFocus={false}
                size="sm"
            />
            <ContentDivider type="single-line" />
            <Popover.Body className="BoardLinkList min-h-0 flex-1 overflow-y-auto p-2">
                <BoardLinkList boards={filteredBoards} gridSize={gridSize} onSelect={handleBoardSelect} size={'sm'} />
            </Popover.Body>
        </div>
    );
};

export default BoardLinkPopupContent;
